"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clock_1 = require("@almservices-cl/clock");
const MessageSent_1 = __importDefault(require("./MessageSent"));
const exception_1 = require("@almservices-cl/exception");
class Chat {
    constructor(pbpApi, pmpApi, chatCache, chatQueue, identityService, messageFactory, eventBus, httpClient) {
        this.isOffline = false;
        this.after = async (application, _userTimeZone, afterId, withMemberId = null) => {
            const messages = await this.chatCache.after(this.isOffline, async () => {
                var _a, _b;
                return (_b = (_a = this.getApi(application)).after) === null || _b === void 0 ? void 0 : _b.call(_a, afterId, withMemberId);
            }, withMemberId, afterId);
            let isMoreMessage = false;
            if (messages.length === 20) {
                messages.shift();
                isMoreMessage = true;
            }
            if (!afterId) {
                const queueMessages = await this.chatQueue.getPending(application);
                const myId = await this.identityService.getId();
                const myDisplayName = await this.identityService.getDisplayName();
                for (let i = 0; i < queueMessages.length; ++i) {
                    if (withMemberId !== null &&
                        queueMessages[i].memberId !== withMemberId) {
                        continue;
                    }
                    messages.push(this.messageFactory.make(myId, myDisplayName, queueMessages[i].message, clock_1.UTCTimeZone.fromString(queueMessages[i].timeZone), null));
                }
            }
            return {
                messages: await Promise.all(messages.map(this.checkMessageAttachment)),
                isMoreMessage,
            };
        };
        this.before = async (application, beforeId, _timeZone, withMemberId) => {
            const limit = 10 + 1; // if eleventh message exist then set isMoreMessages to true
            const messages = await this.chatCache.before(this.isOffline, async () => this.getApi(application).before(limit, beforeId, withMemberId), withMemberId, beforeId);
            let isMoreMessage = false;
            if (messages.length === 11) {
                messages.shift();
                isMoreMessage = true;
            }
            try {
                return {
                    messages: await Promise.all(messages.map(this.checkMessageAttachment)),
                    isMoreMessage,
                };
            }
            catch (e) {
                if (e instanceof Error) {
                    throw Error(e.message);
                }
                throw new exception_1.RuntimeException("Runtime error occured when checking message attachement");
            }
        };
        this.send = async (application, message, timeZone, toMemberId, attachmentMediaId) => {
            try {
                if (this.isOffline) {
                    await this.chatQueue.queue(message, timeZone, application, toMemberId);
                    return;
                }
                const id = await this.getApi(application).send(message, toMemberId, attachmentMediaId);
                return this.chatCache.push(this.messageFactory.make(await this.identityService.getId(), await this.identityService.getDisplayName(), message, timeZone, id), toMemberId);
            }
            finally {
                if (toMemberId) {
                    await this.eventBus.dispatch(new MessageSent_1.default(toMemberId));
                }
            }
        };
        this.mapMessage = (authorId, authorDisplayName, body, timeZone) => this.messageFactory.make(authorId, authorDisplayName, body, timeZone);
        this.authorizeAttachmentSize = async (attachment) => {
            if (!attachment.authRequired)
                return attachment;
            return {
                ...attachment,
                url: await this.httpClient.get(attachment.url, null),
            };
        };
        this.checkMessageAttachment = async (message) => {
            var _a, _b, _c, _d;
            const { attachment } = message.message;
            if (!attachment || !(attachment === null || attachment === void 0 ? void 0 : attachment.sizes)) {
                return message;
            }
            return {
                ...message,
                message: {
                    ...message.message,
                    attachment: {
                        ...message.message.attachment,
                        sizes: {
                            ...(_a = message.message.attachment) === null || _a === void 0 ? void 0 : _a.sizes,
                            large: await this.authorizeAttachmentSize((_b = message.message.attachment) === null || _b === void 0 ? void 0 : _b.sizes.large),
                            medium: await this.authorizeAttachmentSize((_c = message.message.attachment) === null || _c === void 0 ? void 0 : _c.sizes.medium),
                            thumbnail: await this.authorizeAttachmentSize((_d = message.message.attachment) === null || _d === void 0 ? void 0 : _d.sizes.thumbnail),
                        },
                    },
                },
            };
        };
        this.sendAttachment = async (application, attachment, caption, memberId, galleryId) => {
            const message = await this.getApi(application).sendAttachment(attachment, caption, memberId, galleryId);
            return (await this.checkMessageAttachment({ message })).message;
        };
        this.getApi = (application) => application == "PBP" ? this.pbpApi : this.pmpApi;
        this.identityService = identityService;
        this.chatCache = chatCache;
        this.chatQueue = chatQueue;
        this.pbpApi = pbpApi;
        this.pmpApi = pmpApi;
        this.messageFactory = messageFactory;
        this.eventBus = eventBus;
        this.httpClient = httpClient;
    }
    async goOffline() {
        this.isOffline = true;
    }
    async goOnline() {
        this.isOffline = false;
    }
}
exports.default = Chat;
//# sourceMappingURL=Chat.js.map